import * as sharedOfferTypesSpecifications from '../../common/vehicleSpecifications/offerTypes.js'

// Define only the vehicle specifications that are different from the common ones
export const OFFER_TYPES = {...sharedOfferTypesSpecifications.OFFER_TYPES}
export const OFFER_TYPES_IDS = {...sharedOfferTypesSpecifications.OFFER_TYPES_IDS}

export const DEFAULT_OFFER_TYPE_ID_BY_LISTING_SECTION_ID = {
  ...sharedOfferTypesSpecifications.DEFAULT_OFFER_TYPE_ID_BY_LISTING_SECTION_ID
}

export const DEFAULT_REQUEST_OFFER_TYPE_IDS_BY_LISTING_SECTION_ID = {
  ...sharedOfferTypesSpecifications.DEFAULT_REQUEST_OFFER_TYPE_IDS_BY_LISTING_SECTION_ID
}
